export default defineNuxtRouteMiddleware(async (to) => {
  const nuxtApp = useNuxtApp();
  const locale = nuxtApp.$i18n.locale.value;

  const { isProfessionalStore } = useStore();
  const { getCustomerByToken } = useCustomer();
  const { isAccountPath, isPublicPath, getLocalizedPaths } = useRoutePaths();

  const paths = getLocalizedPaths(locale);

  let isAuthenticated = false;

  const isPublic = isPublicPath(to.path, locale);
  const isAccount = isAccountPath(to.path, locale);

  if (isProfessionalStore) {
    // Determine authentication state based on server or client
    if (process.server) {
      const contextToken = useCookie('sw-context-token');
      const customer = await getCustomerByToken(contextToken.value);
      isAuthenticated = Boolean(customer);
    } else {
      const loggedIn = useCookie('sw-logged-in');
      isAuthenticated = Boolean(loggedIn.value);
    }

    // Redirect unauthenticated users from protected routes to login
    if (!isAuthenticated && !isPublic) {
      return navigateTo(paths.login, { replace: true });
    }

    // Redirect authenticated users away from public/auth pages
    if (isAuthenticated && isPublic) {
      return navigateTo(paths.home, { replace: true });
    }

    if (isAccount) {
      return navigateTo(paths.account, { replace: true });
    }
  } else {
    if (isPublic || isAccount) {
      return navigateTo(paths.home, { replace: true });
    }
  }
});
